//  ===================

import { Team__Aliados } from "./teams/Aliados";
import { Team__Cerveceros_MAIN } from "./teams/Cerveceros_MAIN";
import { Team__Apaches } from "./teams/Apaches";

import { Team__MeanMachine } from "./teams/MeanMachine";

import { Team__Nogaleros } from "./teams/Nogaleros";

import { Team__BallBrothers } from "./teams/BallBrothers";
import { Team__UT } from "./teams/UT";
import { Team__XLobos } from "./teams/XLobos";

const GroupA = [Team__Nogaleros, Team__Aliados, Team__XLobos, Team__Apaches];

const GroupB = [
  Team__Cerveceros_MAIN,
  Team__BallBrothers,
  Team__UT,
  Team__MeanMachine,
];

export const Groups_2025_A = [GroupA, GroupB];
